import * as i0 from '@angular/core';
import { Injectable, Component, NgModule, Input, Inject, EventEmitter, forwardRef, Output, ViewChild } from '@angular/core';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/router';
import { RouterModule, defaultUrlMatcher, RouterLink } from '@angular/router';
import * as i3 from '@angular/material/menu';
import { MatMenuModule } from '@angular/material/menu';
import * as i4 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i1$2 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { lastValueFrom } from 'rxjs';
import * as i5 from '@angular/material/table';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import * as i9 from '@angular/material/sort';
import { MatSort, MatSortModule } from '@angular/material/sort';
import * as i8 from '@angular/material/paginator';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import * as i6 from '@angular/forms';
import { FormGroup, NG_VALUE_ACCESSOR, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i3$1 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i3$2 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i4$1 from '@angular/material/core';
import { MatNativeDateModule } from '@angular/material/core';
import * as i4$2 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i10 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i11 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import * as i12 from 'ngx-mask';
import { NgxMaskDirective } from 'ngx-mask';
import * as i13 from 'ngx-currency';
import { NgxCurrencyDirective } from 'ngx-currency';
import * as i14 from '@angular/material/slider';
import { MatSliderModule } from '@angular/material/slider';
import * as i4$3 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i1$3 from '@angular/common/http';
import * as i2$1 from 'ngx-toastr';
import * as i3$3 from 'ngx-spinner';

class UiService {
    constructor() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UiService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UiService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class UiComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UiComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: UiComponent, selector: "lib-ui", ngImport: i0, template: `
    <p>
      ui works!
    </p>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UiComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-ui', template: `
    <p>
      ui works!
    </p>
  ` }]
        }] });

class UiModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: UiModule, declarations: [UiComponent], exports: [UiComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UiModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: UiModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        UiComponent
                    ],
                    imports: [],
                    exports: [
                        UiComponent
                    ]
                }]
        }] });

class ComponentesPadraoService {
    constructor() { }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ComponentesPadraoService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ComponentesPadraoService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ComponentesPadraoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class ComponentesPadraoComponent {
    async ngOnInit() {
        console.log("Carregado!");
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ComponentesPadraoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ComponentesPadraoComponent, selector: "lib-componentes-padrao", ngImport: i0, template: `
    <p>
      componentes-padrao works!
    </p>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ComponentesPadraoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-componentes-padrao', template: `
    <p>
      componentes-padrao works!
    </p>
  ` }]
        }] });

class ComponentNameComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ComponentNameComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ComponentNameComponent, selector: "lib-component-name", ngImport: i0, template: "<p>component-name works!</p>\r\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ComponentNameComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-component-name', template: "<p>component-name works!</p>\r\n" }]
        }] });

class ComponentesPadraoModule {
    constructor() {
        console.log("Modulo carregado!");
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ComponentesPadraoModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ComponentesPadraoModule, declarations: [ComponentesPadraoComponent,
            ComponentNameComponent], imports: [CommonModule], exports: [ComponentesPadraoComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ComponentesPadraoModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ComponentesPadraoModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ComponentesPadraoComponent,
                        ComponentNameComponent
                    ],
                    imports: [
                        CommonModule,
                    ],
                    exports: [
                        ComponentesPadraoComponent
                    ]
                }]
        }], ctorParameters: function () { return []; } });

class BadgeStatusComponent {
    constructor() {
        this.name = '';
        this.color = '';
    }
    ngOnInit() {
        this.color = 'badge ' + this.color;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BadgeStatusComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: BadgeStatusComponent, selector: "app-badge-status", inputs: { name: "name", color: "color" }, ngImport: i0, template: "<span [class]=\"color\">{{name}}</span>\r\n", styles: ["span{margin-left:1%}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BadgeStatusComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-badge-status', template: "<span [class]=\"color\">{{name}}</span>\r\n", styles: ["span{margin-left:1%}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { name: [{
                type: Input
            }], color: [{
                type: Input
            }] } });

class BadgeStatusModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BadgeStatusModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: BadgeStatusModule, declarations: [BadgeStatusComponent], imports: [CommonModule], exports: [BadgeStatusComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BadgeStatusModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BadgeStatusModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        BadgeStatusComponent
                    ],
                    exports: [
                        BadgeStatusComponent
                    ],
                    imports: [
                        CommonModule
                    ]
                }]
        }] });

class ButtonMenuComponent {
    constructor(router) {
        this.router = router;
        this.label = "";
        this.menus = [];
        this.color = 'accent';
        this.yPosition = 'below';
        this.xPosition = 'before';
    }
    ngOnInit() {
    }
    redirect(url) {
        this.router.navigate([url]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonMenuComponent, deps: [{ token: i1.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ButtonMenuComponent, selector: "app-button-menu", inputs: { label: "label", menus: "menus", color: "color", yPosition: "yPosition", xPosition: "xPosition" }, ngImport: i0, template: "<button mat-button mat-raised-button [color]=\"color\" [matMenuTriggerFor]=\"menu\">{{label}}</button>\r\n<mat-menu #menu=\"matMenu\" [yPosition]=\"yPosition\" [xPosition]=\"xPosition\">\r\n    <button [disabled]=\"button.disabled\" (click)=\"button?.callback()\" mat-menu-item *ngFor=\"let button of menus\">{{button.name}}</button>\r\n</mat-menu>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i3.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "component", type: i3.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i3.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "component", type: i4.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-button-menu', template: "<button mat-button mat-raised-button [color]=\"color\" [matMenuTriggerFor]=\"menu\">{{label}}</button>\r\n<mat-menu #menu=\"matMenu\" [yPosition]=\"yPosition\" [xPosition]=\"xPosition\">\r\n    <button [disabled]=\"button.disabled\" (click)=\"button?.callback()\" mat-menu-item *ngFor=\"let button of menus\">{{button.name}}</button>\r\n</mat-menu>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.Router }]; }, propDecorators: { label: [{
                type: Input
            }], menus: [{
                type: Input
            }], color: [{
                type: Input
            }], yPosition: [{
                type: Input
            }], xPosition: [{
                type: Input
            }] } });

class ButtonMenuModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ButtonMenuModule, declarations: [ButtonMenuComponent], imports: [CommonModule,
            MatMenuModule,
            MatButtonModule,
            RouterModule], exports: [ButtonMenuComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonMenuModule, imports: [CommonModule,
            MatMenuModule,
            MatButtonModule,
            RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ButtonMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ButtonMenuComponent
                    ],
                    imports: [
                        CommonModule,
                        MatMenuModule,
                        MatButtonModule,
                        RouterModule,
                    ],
                    exports: [
                        ButtonMenuComponent,
                    ]
                }]
        }] });

class ModalDialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    async ngOnInit() {
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalDialogComponent, deps: [{ token: i1$2.MatDialogRef }, { token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ModalDialogComponent, selector: "app-modal-dialog", ngImport: i0, template: "<div class=\"modal-confirmacao\">\r\n  <h2 mat-dialog-title>{{data.title}}</h2>\r\n  <mat-dialog-content [innerHTML]=\"data.bodyContent\" *ngIf=\"data.isHtml\"></mat-dialog-content>\r\n  <mat-dialog-content *ngIf=\"!data.isHtml\">{{data.bodyContent}}</mat-dialog-content>\r\n  <mat-dialog-actions>\r\n    <div class=\"row\">\r\n      <div class=\"col-12 pull-right\">\r\n        <button mat-button mat-raised-button color=\"primary\" [mat-dialog-close]=\"data.okReturn\">{{data.okTitle}}</button>\r\n        <button mat-button [mat-dialog-close]=\"data.cancelReturn\">{{data.cancelTitle}}</button>\r\n      </div>\r\n    </div>\r\n  </mat-dialog-actions>\r\n</div>\r\n", styles: ["div.modal-confirmacao{width:100%;min-height:3em}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$2.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$2.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$2.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$2.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "component", type: i4.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-modal-dialog', template: "<div class=\"modal-confirmacao\">\r\n  <h2 mat-dialog-title>{{data.title}}</h2>\r\n  <mat-dialog-content [innerHTML]=\"data.bodyContent\" *ngIf=\"data.isHtml\"></mat-dialog-content>\r\n  <mat-dialog-content *ngIf=\"!data.isHtml\">{{data.bodyContent}}</mat-dialog-content>\r\n  <mat-dialog-actions>\r\n    <div class=\"row\">\r\n      <div class=\"col-12 pull-right\">\r\n        <button mat-button mat-raised-button color=\"primary\" [mat-dialog-close]=\"data.okReturn\">{{data.okTitle}}</button>\r\n        <button mat-button [mat-dialog-close]=\"data.cancelReturn\">{{data.cancelTitle}}</button>\r\n      </div>\r\n    </div>\r\n  </mat-dialog-actions>\r\n</div>\r\n", styles: ["div.modal-confirmacao{width:100%;min-height:3em}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.MatDialogRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

class ModalDialogService {
    constructor(dialog) {
        this.dialog = dialog;
    }
    async showModalConfirm(message, title = 'Atenção!') {
        const ret = this.dialog.open(ModalDialogComponent, {
            data: {
                title: title,
                okTitle: 'Sim',
                cancelTitle: 'Não',
                isHtml: true,
                bodyContent: message,
                okReturn: true,
                cancelReturn: false,
            },
            autoFocus: true,
            role: "alertdialog",
            minWidth: '70%',
            maxWidth: '80%',
        });
        return await lastValueFrom(ret.afterClosed()) ?? false;
    }
    async showModal(config) {
        const ret = this.dialog.open(ModalDialogComponent, {
            data: config,
            autoFocus: true,
            role: "alertdialog",
            minWidth: '70%',
            maxWidth: '80%',
        });
        return await lastValueFrom(ret.afterClosed());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalDialogService, deps: [{ token: i1$2.MatDialog }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalDialogService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalDialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.MatDialog }]; } });

class ModalDialogModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ModalDialogModule, declarations: [ModalDialogComponent], imports: [CommonModule,
            MatDialogModule,
            MatButtonModule], exports: [ModalDialogComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalDialogModule, providers: [
            ModalDialogService,
        ], imports: [CommonModule,
            MatDialogModule,
            MatButtonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ModalDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ModalDialogComponent
                    ],
                    exports: [
                        ModalDialogComponent
                    ],
                    providers: [
                        ModalDialogService,
                    ],
                    imports: [
                        CommonModule,
                        MatDialogModule,
                        MatButtonModule,
                    ]
                }]
        }] });

var FilterType;
(function (FilterType) {
    FilterType[FilterType["String"] = 0] = "String";
    FilterType[FilterType["Number"] = 1] = "Number";
    FilterType[FilterType["Date"] = 2] = "Date";
    FilterType[FilterType["DateTime"] = 3] = "DateTime";
    FilterType[FilterType["DateRange"] = 4] = "DateRange";
    FilterType[FilterType["DateTimeRange"] = 5] = "DateTimeRange";
    FilterType[FilterType["Select"] = 6] = "Select";
    FilterType[FilterType["SelectMultiple"] = 7] = "SelectMultiple";
    FilterType[FilterType["AutoComplete"] = 8] = "AutoComplete";
    FilterType[FilterType["Radio"] = 9] = "Radio";
    FilterType[FilterType["Checkbox"] = 10] = "Checkbox";
    FilterType[FilterType["Money"] = 11] = "Money";
    FilterType[FilterType["MoneyRange"] = 12] = "MoneyRange";
    FilterType[FilterType["NumberRange"] = 13] = "NumberRange";
})(FilterType || (FilterType = {}));

const Constants = {
    MASK_CPF: "000.000.000-00",
    MASK_CNPJ: "00.000.000/0000-00",
    MASK_CELULAR: "(99) 99999-9999",
    MASK_FIXO: "(99) 9999-9999",
    MASK_CEP: "99999-999",
    CARACTERES_ESPECIAIS: [
        '[',
        ']',
        '(',
        ')',
        '-',
        '/',
        '\\',
        '.',
    ],
};
const ngxMaskConfig = {
    thousandSeparator: ".",
    decimalMarker: ",",
    allowNegativeNumbers: true,
};
const defaultNgxCurrency = {
    prefix: 'R$ ',
    thousands: '.',
    decimal: ',',
    align: 'left',
    allowZero: true,
    allowNegative: true,
    precision: 2,
    suffix: '',
    nullable: true,
};

class SelectComponent {
    constructor() {
        this.selected = {};
        this.label = "";
        this.options = [];
        this.required = false;
        this.readonly = false;
        this.formControlName = "";
        this.formGroup = new FormGroup({});
        this.hint = "";
        this.selectionChange = new EventEmitter();
    }
    ngOnInit() {
    }
    registerOnChange(fn) {
    }
    registerOnTouched(fn) {
    }
    setDisabledState(isDisabled) {
    }
    writeValue(obj) {
    }
    selectItem(event) {
        this.selectionChange.emit(event.value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SelectComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: SelectComponent, selector: "app-select", inputs: { label: "label", options: "options", required: "required", readonly: "readonly", formControlName: "formControlName", formGroup: "formGroup", hint: "hint" }, outputs: { selectionChange: "selectionChange" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SelectComponent),
                multi: true
            }
        ], ngImport: i0, template: "<mat-form-field [formGroup]=\"formGroup\" style=\"width: 100%\">\r\n    <mat-label>{{label}}</mat-label>\r\n    <mat-select [required]=\"required\" [formControlName]=\"formControlName\" (selectionChange)=\"selectItem($event)\">\r\n        <mat-option>(Selecione)</mat-option>\r\n        <mat-option *ngFor=\"let option of options\" [value]=\"option.value\">{{option.option}}</mat-option>\r\n    </mat-select>\r\n    <mat-hint *ngIf=\"hint\">{{hint}}</mat-hint>\r\n</mat-form-field>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3$1.MatLabel, selector: "mat-label" }, { kind: "directive", type: i3$1.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "component", type: i3$2.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex", "panelWidth", "hideSingleSelectionIndicator"], exportAs: ["matSelect"] }, { kind: "component", type: i4$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i6.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i6.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-select', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => SelectComponent),
                            multi: true
                        }
                    ], template: "<mat-form-field [formGroup]=\"formGroup\" style=\"width: 100%\">\r\n    <mat-label>{{label}}</mat-label>\r\n    <mat-select [required]=\"required\" [formControlName]=\"formControlName\" (selectionChange)=\"selectItem($event)\">\r\n        <mat-option>(Selecione)</mat-option>\r\n        <mat-option *ngFor=\"let option of options\" [value]=\"option.value\">{{option.option}}</mat-option>\r\n    </mat-select>\r\n    <mat-hint *ngIf=\"hint\">{{hint}}</mat-hint>\r\n</mat-form-field>\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { label: [{
                type: Input
            }], options: [{
                type: Input
            }], required: [{
                type: Input
            }], readonly: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], formGroup: [{
                type: Input
            }], hint: [{
                type: Input
            }], selectionChange: [{
                type: Output
            }] } });

class DatepickerComponent {
    constructor() {
        this.formGroup = {};
        this.formControlName = "";
        this.label = "";
        this.readonly = false;
        this.disabled = false;
        this.required = false;
        this.hint = '';
        this.appearance = 'fill';
        this.minDate = null;
        this.maxDate = null;
        this.onChange = () => { };
        this.onTouch = () => { };
    }
    ngOnInit() {
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    writeValue(input) {
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DatepickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: DatepickerComponent, selector: "app-datepicker", inputs: { formGroup: "formGroup", formControlName: "formControlName", label: "label", readonly: "readonly", disabled: "disabled", required: "required", hint: "hint", appearance: "appearance", minDate: "minDate", maxDate: "maxDate" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DatepickerComponent),
                multi: true
            }
        ], ngImport: i0, template: "<mat-form-field [appearance]=\"appearance\" class=\"example-form-field\" [formGroup]=\"formGroup\">\r\n    <mat-label>{{label}}</mat-label>\r\n    <input [min]=\"minDate\" [max]=\"maxDate\" [disabled]=\"disabled\" [readonly]=\"readonly\" [required]=\"required\" matInput [matDatepicker]=\"datepicker\" [formControlName]=\"formControlName\">\r\n    <mat-datepicker-toggle matSuffix [for]=\"datepicker\"></mat-datepicker-toggle>\r\n    <mat-datepicker #datepicker>\r\n        <mat-datepicker-actions>\r\n            <button mat-button matDatepickerCancel>Fechar</button>\r\n            <button mat-raised-button color=\"primary\" matDatepickerApply>Ok</button>\r\n        </mat-datepicker-actions>\r\n    </mat-datepicker>\r\n    <mat-hint *ngIf=\"hint\">{{hint}}</mat-hint>\r\n</mat-form-field>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i3$1.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3$1.MatLabel, selector: "mat-label" }, { kind: "directive", type: i3$1.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i3$1.MatSuffix, selector: "[matSuffix], [matIconSuffix], [matTextSuffix]", inputs: ["matTextSuffix"] }, { kind: "component", type: i4$2.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { kind: "directive", type: i4$2.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { kind: "component", type: i4$2.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { kind: "component", type: i4$2.MatDatepickerActions, selector: "mat-datepicker-actions, mat-date-range-picker-actions" }, { kind: "directive", type: i4$2.MatDatepickerCancel, selector: "[matDatepickerCancel], [matDateRangePickerCancel]" }, { kind: "directive", type: i4$2.MatDatepickerApply, selector: "[matDatepickerApply], [matDateRangePickerApply]" }, { kind: "component", type: i4.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i6.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i6.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DatepickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-datepicker', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => DatepickerComponent),
                            multi: true
                        }
                    ], template: "<mat-form-field [appearance]=\"appearance\" class=\"example-form-field\" [formGroup]=\"formGroup\">\r\n    <mat-label>{{label}}</mat-label>\r\n    <input [min]=\"minDate\" [max]=\"maxDate\" [disabled]=\"disabled\" [readonly]=\"readonly\" [required]=\"required\" matInput [matDatepicker]=\"datepicker\" [formControlName]=\"formControlName\">\r\n    <mat-datepicker-toggle matSuffix [for]=\"datepicker\"></mat-datepicker-toggle>\r\n    <mat-datepicker #datepicker>\r\n        <mat-datepicker-actions>\r\n            <button mat-button matDatepickerCancel>Fechar</button>\r\n            <button mat-raised-button color=\"primary\" matDatepickerApply>Ok</button>\r\n        </mat-datepicker-actions>\r\n    </mat-datepicker>\r\n    <mat-hint *ngIf=\"hint\">{{hint}}</mat-hint>\r\n</mat-form-field>\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { formGroup: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], label: [{
                type: Input
            }], readonly: [{
                type: Input
            }], disabled: [{
                type: Input
            }], required: [{
                type: Input
            }], hint: [{
                type: Input
            }], appearance: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }] } });

class AdvancedFilterComponent {
    async ngOnInit() {
    }
    constructor(config) {
        this.config = config;
        this.form = new FormGroup({});
        this.FilterType = FilterType;
        this.defaultUrlMatcher = defaultUrlMatcher;
        this.ngxMaskConfig = ngxMaskConfig;
        this.defaultNgxCurrency = defaultNgxCurrency;
        this.Number = Number;
        const ranges = [
            FilterType.DateTimeRange,
            FilterType.NumberRange,
            FilterType.MoneyRange,
        ];
        for (let field of this.config.fields) {
            let validatorOptions = [];
            if (field.type == FilterType.Checkbox) {
                validatorOptions.push(Validators.required);
                field.defaultValue = false;
            }
            const check = ranges.findIndex(q => q == field.type);
            if (check >= 0) {
                this.form.addControl(field.formControlName + "_MINIMO", new FormControl(field.defaultValue ?? "", validatorOptions));
                this.form.addControl(field.formControlName + "_MAXIMO", new FormControl(field.defaultValue ?? "", validatorOptions));
            }
            else {
                this.form.addControl(field.formControlName, new FormControl(field.defaultValue ?? "", validatorOptions));
            }
        }
        this.form.patchValue(this.config.previousForm);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AdvancedFilterComponent, deps: [{ token: MAT_DIALOG_DATA }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: AdvancedFilterComponent, selector: "lib-advanced-filter", ngImport: i0, template: "<h1 mat-dialog-title>{{ config.title }}</h1>\n<div mat-dialog-content>\n  <form [formGroup]=\"form\">\n    <div class=\"row\">\n      <div *ngFor=\"let field of config.fields\" [class]=\"'col-xs-12 col-md-' + field.columnSize.toString()\">\n        <mat-form-field *ngIf=\"field.type == FilterType.String\">\n          <mat-label>{{field.label}}</mat-label>\n          <input type=\"text\" matInput [formControlName]=\"field.formControlName\" [mask]=\"field.mask\">\n          <mat-hint *ngIf=\"field.hint\">{{field.hint}}</mat-hint>\n        </mat-form-field>\n        <app-select *ngIf=\"field.type == FilterType.Select || field.type == FilterType.SelectMultiple\"\n                    [formGroup]=\"form\"\n                    [formControlName]=\"field.formControlName\"\n                    [label]=\"field.label\"\n                    [options]=\"field.values ?? []\"\n                    [hint]=\"field.hint ?? ''\"\n        ></app-select>\n        <app-datepicker *ngIf=\"field.type == FilterType.DateTime || field.type == FilterType.Date\"\n                        [formGroup]=\"form\"\n                        [formControlName]=\"field.formControlName\"\n                        [label]=\"field.label\"\n                        [hint]=\"field.hint ?? ''\"\n        ></app-datepicker>\n\n        <div *ngIf=\"field.type == FilterType.Radio\">\n          <label>{{field.label}}</label>\n          <br>\n          <mat-radio-group [formControlName]=\"field.formControlName\">\n            <mat-radio-button *ngFor=\"let optionRadio of field.values\" [value]=\"optionRadio.value\">{{optionRadio.option}}</mat-radio-button>\n          </mat-radio-group>\n        </div>\n\n        <mat-checkbox *ngIf=\"field.type == FilterType.Checkbox\" [formControlName]=\"field.formControlName\" value=\"1\">{{field.label}}</mat-checkbox>\n\n        <mat-form-field *ngIf=\"field.type == FilterType.Money\">\n          <mat-label>{{field.label}}</mat-label>\n          <input type=\"text\" matInput [formControlName]=\"field.formControlName\" currencyMask [options]=\"defaultNgxCurrency\">\n          <mat-hint *ngIf=\"field.hint\">{{field.hint}}</mat-hint>\n        </mat-form-field>\n\n        <mat-slider [min]=\"field.min\"\n                    [max]=\"field.max\"\n                    [formControlName]=\"field.formControlName\"\n                    [step]=\"field.step\"\n                    *ngIf=\"field.type == FilterType.NumberRange\"\n        >\n          <input matSliderStartThumb>\n          <input matSliderEndThumb>\n        </mat-slider>\n\n        <mat-form-field *ngIf=\"field.type == FilterType.DateTimeRange || field.type == FilterType.DateRange\">\n          <mat-label>{{field.label}}</mat-label>\n          <mat-date-range-input [rangePicker]=\"picker\" [formGroup]=\"form\">\n            <input [formControlName]=\"field.formControlName + '_MINIMO'\" matStartDate placeholder=\"In\u00EDcio\">\n            <input [formControlName]=\"field.formControlName + '_MAXIMO'\" matEndDate placeholder=\"Fim\">\n          </mat-date-range-input>\n          <mat-hint>{{field.hint}}</mat-hint>\n          <mat-datepicker-toggle matIconSuffix [for]=\"picker\"></mat-datepicker-toggle>\n          <mat-date-range-picker #picker></mat-date-range-picker>\n        </mat-form-field>\n\n        <div class=\"row\" *ngIf=\"field.type == FilterType.MoneyRange\">\n          <div class=\"col-xs-12 col-md-6\">\n            <mat-form-field>\n              <mat-label>{{ field.label + ' (M\u00EDnimo)' }}</mat-label>\n              <input matInput #from currencyMask [options]=\"defaultNgxCurrency\" [formControlName]=\"field.formControlName + '_MINIMO'\" [max]=\"to.value\">\n            </mat-form-field>\n          </div>\n          <div class=\"col-xs-12 col-md-6\">\n            <mat-form-field>\n              <mat-label>{{ field.label + ' (M\u00E1ximo)' }}</mat-label>\n              <input matInput #to currencyMask [options]=\"defaultNgxCurrency\" [formControlName]=\"field.formControlName + '_MAXIMO'\" [min]=\"from.value\">\n            </mat-form-field>\n          </div>\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n<div mat-dialog-actions>\n  <button mat-button mat-raised-button color=\"primary\" [mat-dialog-close]=\"form.getRawValue()\">Filtrar</button>\n  <button mat-button [mat-dialog-close]=\"false\">Fechar</button>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i2.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i3$1.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3$1.MatLabel, selector: "mat-label" }, { kind: "directive", type: i3$1.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i3$1.MatSuffix, selector: "[matSuffix], [matIconSuffix], [matTextSuffix]", inputs: ["matTextSuffix"] }, { kind: "directive", type: i1$2.MatDialogClose, selector: "[mat-dialog-close], [matDialogClose]", inputs: ["aria-label", "type", "mat-dialog-close", "matDialogClose"], exportAs: ["matDialogClose"] }, { kind: "directive", type: i1$2.MatDialogTitle, selector: "[mat-dialog-title], [matDialogTitle]", inputs: ["id"], exportAs: ["matDialogTitle"] }, { kind: "directive", type: i1$2.MatDialogContent, selector: "[mat-dialog-content], mat-dialog-content, [matDialogContent]" }, { kind: "directive", type: i1$2.MatDialogActions, selector: "[mat-dialog-actions], mat-dialog-actions, [matDialogActions]", inputs: ["align"] }, { kind: "directive", type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i6.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i6.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: SelectComponent, selector: "app-select", inputs: ["label", "options", "required", "readonly", "formControlName", "formGroup", "hint"], outputs: ["selectionChange"] }, { kind: "component", type: DatepickerComponent, selector: "app-datepicker", inputs: ["formGroup", "formControlName", "label", "readonly", "disabled", "required", "hint", "appearance", "minDate", "maxDate"] }, { kind: "component", type: i4$2.MatDatepickerToggle, selector: "mat-datepicker-toggle", inputs: ["for", "tabIndex", "aria-label", "disabled", "disableRipple"], exportAs: ["matDatepickerToggle"] }, { kind: "component", type: i4$2.MatDateRangeInput, selector: "mat-date-range-input", inputs: ["rangePicker", "required", "dateFilter", "min", "max", "disabled", "separator", "comparisonStart", "comparisonEnd"], exportAs: ["matDateRangeInput"] }, { kind: "directive", type: i4$2.MatStartDate, selector: "input[matStartDate]", inputs: ["errorStateMatcher"], outputs: ["dateChange", "dateInput"] }, { kind: "directive", type: i4$2.MatEndDate, selector: "input[matEndDate]", inputs: ["errorStateMatcher"], outputs: ["dateChange", "dateInput"] }, { kind: "component", type: i4$2.MatDateRangePicker, selector: "mat-date-range-picker", exportAs: ["matDateRangePicker"] }, { kind: "component", type: i10.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }, { kind: "directive", type: i11.MatRadioGroup, selector: "mat-radio-group", exportAs: ["matRadioGroup"] }, { kind: "component", type: i11.MatRadioButton, selector: "mat-radio-button", inputs: ["disableRipple", "tabIndex"], exportAs: ["matRadioButton"] }, { kind: "directive", type: i12.NgxMaskDirective, selector: "input[mask], textarea[mask]", inputs: ["mask", "specialCharacters", "patterns", "prefix", "suffix", "thousandSeparator", "decimalMarker", "dropSpecialCharacters", "hiddenInput", "showMaskTyped", "placeHolderCharacter", "shownMaskExpression", "showTemplate", "clearIfNotMatch", "validation", "separatorLimit", "allowNegativeNumbers", "leadZeroDateTime", "leadZero", "triggerOnMaskChange", "apm", "inputTransformFn", "outputTransformFn", "keepCharacterPositions"], outputs: ["maskFilled"], exportAs: ["mask", "ngxMask"] }, { kind: "directive", type: i13.NgxCurrencyDirective, selector: "[currencyMask]", inputs: ["options"] }, { kind: "component", type: i14.MatSlider, selector: "mat-slider", inputs: ["color", "disableRipple", "disabled", "discrete", "showTickMarks", "min", "max", "step", "displayWith"], exportAs: ["matSlider"] }, { kind: "directive", type: i14.MatSliderRangeThumb, selector: "input[matSliderStartThumb], input[matSliderEndThumb]", exportAs: ["matSliderRangeThumb"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AdvancedFilterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-advanced-filter', template: "<h1 mat-dialog-title>{{ config.title }}</h1>\n<div mat-dialog-content>\n  <form [formGroup]=\"form\">\n    <div class=\"row\">\n      <div *ngFor=\"let field of config.fields\" [class]=\"'col-xs-12 col-md-' + field.columnSize.toString()\">\n        <mat-form-field *ngIf=\"field.type == FilterType.String\">\n          <mat-label>{{field.label}}</mat-label>\n          <input type=\"text\" matInput [formControlName]=\"field.formControlName\" [mask]=\"field.mask\">\n          <mat-hint *ngIf=\"field.hint\">{{field.hint}}</mat-hint>\n        </mat-form-field>\n        <app-select *ngIf=\"field.type == FilterType.Select || field.type == FilterType.SelectMultiple\"\n                    [formGroup]=\"form\"\n                    [formControlName]=\"field.formControlName\"\n                    [label]=\"field.label\"\n                    [options]=\"field.values ?? []\"\n                    [hint]=\"field.hint ?? ''\"\n        ></app-select>\n        <app-datepicker *ngIf=\"field.type == FilterType.DateTime || field.type == FilterType.Date\"\n                        [formGroup]=\"form\"\n                        [formControlName]=\"field.formControlName\"\n                        [label]=\"field.label\"\n                        [hint]=\"field.hint ?? ''\"\n        ></app-datepicker>\n\n        <div *ngIf=\"field.type == FilterType.Radio\">\n          <label>{{field.label}}</label>\n          <br>\n          <mat-radio-group [formControlName]=\"field.formControlName\">\n            <mat-radio-button *ngFor=\"let optionRadio of field.values\" [value]=\"optionRadio.value\">{{optionRadio.option}}</mat-radio-button>\n          </mat-radio-group>\n        </div>\n\n        <mat-checkbox *ngIf=\"field.type == FilterType.Checkbox\" [formControlName]=\"field.formControlName\" value=\"1\">{{field.label}}</mat-checkbox>\n\n        <mat-form-field *ngIf=\"field.type == FilterType.Money\">\n          <mat-label>{{field.label}}</mat-label>\n          <input type=\"text\" matInput [formControlName]=\"field.formControlName\" currencyMask [options]=\"defaultNgxCurrency\">\n          <mat-hint *ngIf=\"field.hint\">{{field.hint}}</mat-hint>\n        </mat-form-field>\n\n        <mat-slider [min]=\"field.min\"\n                    [max]=\"field.max\"\n                    [formControlName]=\"field.formControlName\"\n                    [step]=\"field.step\"\n                    *ngIf=\"field.type == FilterType.NumberRange\"\n        >\n          <input matSliderStartThumb>\n          <input matSliderEndThumb>\n        </mat-slider>\n\n        <mat-form-field *ngIf=\"field.type == FilterType.DateTimeRange || field.type == FilterType.DateRange\">\n          <mat-label>{{field.label}}</mat-label>\n          <mat-date-range-input [rangePicker]=\"picker\" [formGroup]=\"form\">\n            <input [formControlName]=\"field.formControlName + '_MINIMO'\" matStartDate placeholder=\"In\u00EDcio\">\n            <input [formControlName]=\"field.formControlName + '_MAXIMO'\" matEndDate placeholder=\"Fim\">\n          </mat-date-range-input>\n          <mat-hint>{{field.hint}}</mat-hint>\n          <mat-datepicker-toggle matIconSuffix [for]=\"picker\"></mat-datepicker-toggle>\n          <mat-date-range-picker #picker></mat-date-range-picker>\n        </mat-form-field>\n\n        <div class=\"row\" *ngIf=\"field.type == FilterType.MoneyRange\">\n          <div class=\"col-xs-12 col-md-6\">\n            <mat-form-field>\n              <mat-label>{{ field.label + ' (M\u00EDnimo)' }}</mat-label>\n              <input matInput #from currencyMask [options]=\"defaultNgxCurrency\" [formControlName]=\"field.formControlName + '_MINIMO'\" [max]=\"to.value\">\n            </mat-form-field>\n          </div>\n          <div class=\"col-xs-12 col-md-6\">\n            <mat-form-field>\n              <mat-label>{{ field.label + ' (M\u00E1ximo)' }}</mat-label>\n              <input matInput #to currencyMask [options]=\"defaultNgxCurrency\" [formControlName]=\"field.formControlName + '_MAXIMO'\" [min]=\"from.value\">\n            </mat-form-field>\n          </div>\n        </div>\n      </div>\n    </div>\n  </form>\n</div>\n<div mat-dialog-actions>\n  <button mat-button mat-raised-button color=\"primary\" [mat-dialog-close]=\"form.getRawValue()\">Filtrar</button>\n  <button mat-button [mat-dialog-close]=\"false\">Fechar</button>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DIALOG_DATA]
                }] }]; } });

class BreadcumbComponent {
    constructor() {
        this.configs = [];
    }
    async ngOnInit() {
    }
    getCssClasses(breadcumb) {
        let ret = "breadcrumb-item";
        if (breadcumb.active) {
            ret += " active";
        }
        return ret;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BreadcumbComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: BreadcumbComponent, selector: "breadcumb", inputs: { configs: "configs" }, ngImport: i0, template: "<nav aria-label=\"breadcrumb\" *ngIf=\"configs.length > 0\">\r\n  <ol class=\"breadcrumb\">\r\n    <li class=\"breadcrumb-item\"><a routerLink=\"/principal\">Home</a></li>\r\n    <li *ngFor=\"let config of configs\" aria-current=\"page\" [class]=\"getCssClasses(config)\"><a [routerLink]=\"config.url\">{{config.name}}</a></li>\r\n  </ol>\r\n</nav>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BreadcumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'breadcumb', template: "<nav aria-label=\"breadcrumb\" *ngIf=\"configs.length > 0\">\r\n  <ol class=\"breadcrumb\">\r\n    <li class=\"breadcrumb-item\"><a routerLink=\"/principal\">Home</a></li>\r\n    <li *ngFor=\"let config of configs\" aria-current=\"page\" [class]=\"getCssClasses(config)\"><a [routerLink]=\"config.url\">{{config.name}}</a></li>\r\n  </ol>\r\n</nav>\r\n" }]
        }], propDecorators: { configs: [{
                type: Input
            }] } });

class ListComponent {
    constructor(router, matDialog) {
        this.router = router;
        this.matDialog = matDialog;
        this.service = {};
        this.title = "";
        this.backendRoute = "";
        this.dataSource = [];
        this.headerFieldConfig = [];
        this.basicRoute = "";
        this.sort = {};
        this.paginator = {};
        this.showCardHeader = true;
        this.showCardFooter = true;
        this.showFilter = true;
        this.resultsCount = 0;
        this.fields = [];
        this.fieldsFormatted = [];
        this.primaryKey = "";
        this.tableSource = {};
        this.breadcumbConfigs = [];
        this.pageEvent = {};
        this.queryEvent = {};
        this.pageSizeOptions = [10, 20, 50, 100];
        this.actionButtons = [];
        this.defaultPageSize = 20;
        this.showFilterButton = true;
        this.advancedFilterConfig = {};
        this.isVisible = false;
        this.userFilter = false;
    }
    async ngOnInit() {
        if (!this.service) {
            console.error("Serviço não definido");
            return;
        }
        this.fields = new Array();
        this.fieldsFormatted = new Array();
        for (const x of this.headerFieldConfig) {
            if (x.visible) {
                this.fields.push(x);
                this.fieldsFormatted.push(x.fieldName);
            }
            if (x.primaryKey) {
                this.primaryKey = x.fieldName;
            }
        }
        if (!this.backendRoute) {
            this.service.toasterDanger("backendRoute não definido", "Erro");
        }
        else {
            await this.queryBackend();
        }
    }
    open(id) {
        this.router.navigate([this.basicRoute + id]);
    }
    formatMatHeaderRowDef(arr) {
        const y = new Array();
        for (const x of arr) {
            y.push(x.fieldName);
        }
        return y;
    }
    async applyFilter(event) {
        this.queryEvent = event;
        this.pageEvent.pageIndex = 0;
        await this.queryBackend();
    }
    async paginate(event) {
        this.pageEvent = event;
        await this.queryBackend();
    }
    /**
     * Faz a requisicao ao backend
     */
    async queryBackend() {
        try {
            this.service.showSpinner();
            const skip = this.pageEvent.pageIndex * this.pageEvent.pageSize ?? 0;
            const page = this.pageEvent.pageIndex ?? 0;
            const filterValue = this.getFilterValue();
            if (this.userFilter !== false) {
                this.resultsCount = await lastValueFrom(this.service.count(this.backendRoute + "/count_advanced", filterValue, this.userFilter));
                this.dataSource = await lastValueFrom(this.service.index(this.backendRoute + "/list_advanced", filterValue, this.userFilter, this.pageEvent.pageSize, skip, '', 'asc', page));
            }
            else {
                this.resultsCount = await lastValueFrom(this.service.count(this.backendRoute + '/count', filterValue));
                this.dataSource = await lastValueFrom(this.service.index(this.backendRoute, filterValue, {}, this.pageEvent.pageSize, skip, '', 'asc', page));
            }
            this.tableSource = new MatTableDataSource(this.dataSource);
        }
        catch (e) {
            if (!this.service) {
                alert("Serviço não configurado");
            }
            else {
                this.service.toasterDanger(e.error.detail ?? e.error ?? 'Houve um erro ao montar a tabela', 'Erro');
            }
            console.error(e);
        }
        finally {
            this.service.hideSpinner();
            this.isVisible = true;
        }
    }
    getFilterValue() {
        const x = this.queryEvent.target;
        if (!x) {
            return "";
        }
        return x.value;
    }
    async new() {
        await this.router.navigate([this.basicRoute + '/new']);
    }
    async showModalFilter() {
        let aux = this.advancedFilterConfig;
        aux.previousForm = this.userFilter;
        let data = {
            minWidth: "60%",
            minHeight: "40%",
            data: aux,
        };
        this.userFilter = await lastValueFrom(this.matDialog.open(AdvancedFilterComponent, data).afterClosed()) ?? false;
        console.log(this.userFilter);
        await this.queryBackend();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ListComponent, deps: [{ token: i1.Router }, { token: i1$2.MatDialog }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ListComponent, selector: "app-list", inputs: { service: "service", title: "title", backendRoute: "backendRoute", dataSource: "dataSource", headerFieldConfig: "headerFieldConfig", basicRoute: "basicRoute", showCardHeader: "showCardHeader", showCardFooter: "showCardFooter", showFilter: "showFilter", resultsCount: "resultsCount", fields: "fields", fieldsFormatted: "fieldsFormatted", primaryKey: "primaryKey", tableSource: "tableSource", breadcumbConfigs: "breadcumbConfigs", pageSizeOptions: "pageSizeOptions", actionButtons: "actionButtons", defaultPageSize: "defaultPageSize", showFilterButton: "showFilterButton", advancedFilterConfig: "advancedFilterConfig" }, viewQueries: [{ propertyName: "sort", first: true, predicate: MatSort, descendants: true }, { propertyName: "paginator", first: true, predicate: MatPaginator, descendants: true }], ngImport: i0, template: "<div class=\"animated fade-in\" *ngIf=\"tableSource?.data?.length ?? 0 > 0 || isVisible\">\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <breadcumb [configs]=\"breadcumbConfigs\"></breadcumb>\r\n    </div>\r\n  </div>\r\n<!--  <div class=\"row\" *ngIf=\"userFilter && userFilter !== {}\">-->\r\n<!--    <div class=\"col-12\">-->\r\n<!--      <div class=\"alert alert-info\">-->\r\n<!--        <h3>Filtros aplicados:</h3>-->\r\n<!--      </div>-->\r\n<!--    </div>-->\r\n<!--  </div>-->\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <div class=\"card\">\r\n        <div class=\"card-header\" *ngIf=\"showCardHeader\">\r\n          <div class=\"row\">\r\n            <div class=\"col-xs-12 col-md-8\">\r\n              <h4>{{title}}</h4>\r\n            </div>\r\n            <div class=\"col-xs-12 col-md-4\">\r\n              <div class=\"pull-right\">\r\n                <button *ngIf=\"showFilterButton\" mat-button mat-raised-button class=\"filtrar\" (click)=\"showModalFilter()\">Filtrar</button>\r\n                <app-button-menu *ngFor=\"let button of actionButtons\" [label]=\"button.label\" [color]=\"button.color\" [menus]=\"button.options\"></app-button-menu>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"card-body\">\r\n            <mat-form-field appearance=\"fill\" color=\"primary\" style=\"width: 100%\" *ngIf=\"showFilter\">\r\n                <mat-label>Filtro</mat-label>\r\n                <input matInput (keyup.enter)=\"applyFilter($event)\" placeholder=\"Digite o termo\" #input>\r\n            </mat-form-field>\r\n            <!--<mat-paginator (page)=\"paginate($event)\"-->\r\n                           <!--[length]=\"resultsCount\"-->\r\n                           <!--[pageSize]=\"20\"-->\r\n                           <!--[pageSizeOptions]=\"[10,20,50,100]\"-->\r\n                           <!--hidePageSize=\"false\"-->\r\n                           <!--showFirstLastButtons=\"true\"-->\r\n                           <!--aria-label=\"Selecionar p\u00E1gina\"-->\r\n            <!--&gt;-->\r\n            <!--</mat-paginator>-->\r\n            <div class=\"table-responsive\" *ngIf=\"tableSource?.data?.length ?? 0 > 0; else semRegistro\">\r\n                <table mat-table [dataSource]=\"tableSource\" matSort class=\"table-list\">\r\n                    <ng-container *ngFor=\"let field of fields\" [matColumnDef]=\"field.fieldName\">\r\n                        <th class=\"text-center\" mat-header-cell mat-sort-header *matHeaderCellDef> {{field.canonicalName}} </th>\r\n                        <td class=\"clickable\" [innerHTML]=\"field.pipe(element[field.fieldName])\" [ngClass]=\"field.columnClasses\" mat-cell *matCellDef=\"let element\"></td>\r\n                    </ng-container>\r\n                    <tr mat-header-row *matHeaderRowDef=\"formatMatHeaderRowDef(fields)\"></tr>\r\n                    <tr class=\"small\" mat-row *matRowDef=\"let row; columns: fieldsFormatted;\" (click)=\"open(row[primaryKey])\">{{row | json}}</tr>\r\n                    <tr class=\"mat-row\" *matNoDataRow>\r\n                        <td class=\"mat-cell\" colspan=\"4\">Nenhum resultado encontrado para o filtro informado</td>\r\n                    </tr>\r\n                </table>\r\n\r\n            </div>\r\n            <ng-template #semRegistro>\r\n              <div class=\"row\">\r\n                <div class=\"col-12\">\r\n                  <div class=\"alert alert-info text-center\">\r\n                    <strong>Nenhum registro encontrado</strong>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </ng-template>\r\n          <mat-paginator (page)=\"paginate($event)\"\r\n                         [length]=\"resultsCount\"\r\n                         [pageSize]=\"defaultPageSize\"\r\n                         [pageSizeOptions]=\"pageSizeOptions\"\r\n                         [hidePageSize]=\"false\"\r\n                         [showFirstLastButtons]=\"true\"\r\n                         aria-label=\"Selecionar p\u00E1gina\"\r\n          >\r\n          </mat-paginator>\r\n        </div>\r\n        <div class=\"card-footer\" *ngIf=\"showCardFooter\">\r\n            <button (click)=\"new()\" color=\"primary\" mat-button mat-raised-button>Incluir</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: ["p.title{font-weight:bolder}.table-list,.full{width:100%}.clickable{cursor:pointer}.pull-right{text-align:right}.filtrar{background-color:#008a27;color:#fff;margin-left:1%;margin-right:1%}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i5.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i5.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i5.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i5.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i5.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i5.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i5.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i5.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i5.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i5.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "directive", type: i5.MatNoDataRow, selector: "ng-template[matNoDataRow]" }, { kind: "directive", type: i2.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i3$1.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3$1.MatLabel, selector: "mat-label" }, { kind: "component", type: i8.MatPaginator, selector: "mat-paginator", inputs: ["disabled"], exportAs: ["matPaginator"] }, { kind: "directive", type: i9.MatSort, selector: "[matSort]", inputs: ["matSortDisabled", "matSortActive", "matSortStart", "matSortDirection", "matSortDisableClear"], outputs: ["matSortChange"], exportAs: ["matSort"] }, { kind: "component", type: i9.MatSortHeader, selector: "[mat-sort-header]", inputs: ["disabled", "mat-sort-header", "arrowPosition", "start", "sortActionDescription", "disableClear"], exportAs: ["matSortHeader"] }, { kind: "component", type: ButtonMenuComponent, selector: "app-button-menu", inputs: ["label", "menus", "color", "yPosition", "xPosition"] }, { kind: "component", type: BreadcumbComponent, selector: "breadcumb", inputs: ["configs"] }, { kind: "pipe", type: i1$1.JsonPipe, name: "json" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-list', template: "<div class=\"animated fade-in\" *ngIf=\"tableSource?.data?.length ?? 0 > 0 || isVisible\">\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <breadcumb [configs]=\"breadcumbConfigs\"></breadcumb>\r\n    </div>\r\n  </div>\r\n<!--  <div class=\"row\" *ngIf=\"userFilter && userFilter !== {}\">-->\r\n<!--    <div class=\"col-12\">-->\r\n<!--      <div class=\"alert alert-info\">-->\r\n<!--        <h3>Filtros aplicados:</h3>-->\r\n<!--      </div>-->\r\n<!--    </div>-->\r\n<!--  </div>-->\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <div class=\"card\">\r\n        <div class=\"card-header\" *ngIf=\"showCardHeader\">\r\n          <div class=\"row\">\r\n            <div class=\"col-xs-12 col-md-8\">\r\n              <h4>{{title}}</h4>\r\n            </div>\r\n            <div class=\"col-xs-12 col-md-4\">\r\n              <div class=\"pull-right\">\r\n                <button *ngIf=\"showFilterButton\" mat-button mat-raised-button class=\"filtrar\" (click)=\"showModalFilter()\">Filtrar</button>\r\n                <app-button-menu *ngFor=\"let button of actionButtons\" [label]=\"button.label\" [color]=\"button.color\" [menus]=\"button.options\"></app-button-menu>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"card-body\">\r\n            <mat-form-field appearance=\"fill\" color=\"primary\" style=\"width: 100%\" *ngIf=\"showFilter\">\r\n                <mat-label>Filtro</mat-label>\r\n                <input matInput (keyup.enter)=\"applyFilter($event)\" placeholder=\"Digite o termo\" #input>\r\n            </mat-form-field>\r\n            <!--<mat-paginator (page)=\"paginate($event)\"-->\r\n                           <!--[length]=\"resultsCount\"-->\r\n                           <!--[pageSize]=\"20\"-->\r\n                           <!--[pageSizeOptions]=\"[10,20,50,100]\"-->\r\n                           <!--hidePageSize=\"false\"-->\r\n                           <!--showFirstLastButtons=\"true\"-->\r\n                           <!--aria-label=\"Selecionar p\u00E1gina\"-->\r\n            <!--&gt;-->\r\n            <!--</mat-paginator>-->\r\n            <div class=\"table-responsive\" *ngIf=\"tableSource?.data?.length ?? 0 > 0; else semRegistro\">\r\n                <table mat-table [dataSource]=\"tableSource\" matSort class=\"table-list\">\r\n                    <ng-container *ngFor=\"let field of fields\" [matColumnDef]=\"field.fieldName\">\r\n                        <th class=\"text-center\" mat-header-cell mat-sort-header *matHeaderCellDef> {{field.canonicalName}} </th>\r\n                        <td class=\"clickable\" [innerHTML]=\"field.pipe(element[field.fieldName])\" [ngClass]=\"field.columnClasses\" mat-cell *matCellDef=\"let element\"></td>\r\n                    </ng-container>\r\n                    <tr mat-header-row *matHeaderRowDef=\"formatMatHeaderRowDef(fields)\"></tr>\r\n                    <tr class=\"small\" mat-row *matRowDef=\"let row; columns: fieldsFormatted;\" (click)=\"open(row[primaryKey])\">{{row | json}}</tr>\r\n                    <tr class=\"mat-row\" *matNoDataRow>\r\n                        <td class=\"mat-cell\" colspan=\"4\">Nenhum resultado encontrado para o filtro informado</td>\r\n                    </tr>\r\n                </table>\r\n\r\n            </div>\r\n            <ng-template #semRegistro>\r\n              <div class=\"row\">\r\n                <div class=\"col-12\">\r\n                  <div class=\"alert alert-info text-center\">\r\n                    <strong>Nenhum registro encontrado</strong>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </ng-template>\r\n          <mat-paginator (page)=\"paginate($event)\"\r\n                         [length]=\"resultsCount\"\r\n                         [pageSize]=\"defaultPageSize\"\r\n                         [pageSizeOptions]=\"pageSizeOptions\"\r\n                         [hidePageSize]=\"false\"\r\n                         [showFirstLastButtons]=\"true\"\r\n                         aria-label=\"Selecionar p\u00E1gina\"\r\n          >\r\n          </mat-paginator>\r\n        </div>\r\n        <div class=\"card-footer\" *ngIf=\"showCardFooter\">\r\n            <button (click)=\"new()\" color=\"primary\" mat-button mat-raised-button>Incluir</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: ["p.title{font-weight:bolder}.table-list,.full{width:100%}.clickable{cursor:pointer}.pull-right{text-align:right}.filtrar{background-color:#008a27;color:#fff;margin-left:1%;margin-right:1%}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.Router }, { type: i1$2.MatDialog }]; }, propDecorators: { service: [{
                type: Input
            }], title: [{
                type: Input
            }], backendRoute: [{
                type: Input
            }], dataSource: [{
                type: Input
            }], headerFieldConfig: [{
                type: Input
            }], basicRoute: [{
                type: Input
            }], sort: [{
                type: ViewChild,
                args: [MatSort]
            }], paginator: [{
                type: ViewChild,
                args: [MatPaginator]
            }], showCardHeader: [{
                type: Input
            }], showCardFooter: [{
                type: Input
            }], showFilter: [{
                type: Input
            }], resultsCount: [{
                type: Input
            }], fields: [{
                type: Input
            }], fieldsFormatted: [{
                type: Input
            }], primaryKey: [{
                type: Input
            }], tableSource: [{
                type: Input
            }], breadcumbConfigs: [{
                type: Input
            }], pageSizeOptions: [{
                type: Input
            }], actionButtons: [{
                type: Input
            }], defaultPageSize: [{
                type: Input
            }], showFilterButton: [{
                type: Input
            }], advancedFilterConfig: [{
                type: Input
            }] } });

class InputComponent {
    constructor() {
        this.label = "";
        this.placeholder = "";
        this.required = false;
        this.readonly = false;
        this.disabled = false;
        this.showLength = false;
        this.value = '';
        this.type = 'text';
        this.step = 'any';
        this.minLength = 0;
        this.maxLength = 0;
        this.length = 0;
        this.hint = "";
        this.appearance = 'fill';
        this.formControlName = '';
        this.formGroup = new FormGroup({});
        this.min = 0;
        this.max = 0;
        this.matAutoComplete = {};
        this.mask = "";
        this.prefix = "";
        this.suffix = "";
        this.specialCharacters = Constants.CARACTERES_ESPECIAIS;
        // c) copy paste this code
        this.onChange = () => { };
        this.onTouch = () => { };
    }
    ngOnInit() {
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    // d) copy paste this code
    writeValue(input) {
        // TODO
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: InputComponent, selector: "app-input", inputs: { label: "label", placeholder: "placeholder", required: "required", readonly: "readonly", disabled: "disabled", showLength: "showLength", value: "value", type: "type", step: "step", minLength: "minLength", maxLength: "maxLength", length: "length", hint: "hint", appearance: "appearance", formControlName: "formControlName", formGroup: "formGroup", min: "min", max: "max", matAutoComplete: "matAutoComplete", mask: "mask", prefix: "prefix", suffix: "suffix", specialCharacters: "specialCharacters" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => InputComponent),
                multi: true
            }
        ], ngImport: i0, template: "<mat-form-field [appearance]=\"appearance\" [formGroup]=\"formGroup\" style=\"width: 100%\">\r\n    <mat-label>{{label}}</mat-label>\r\n    <span *ngIf=\"prefix\">{{prefix}}</span>\r\n    <input matInput\r\n            #inputId\r\n           [placeholder]=\"placeholder\"\r\n           [required]=\"required\"\r\n           [readonly]=\"readonly\"\r\n           [disabled]=\"disabled\"\r\n           [type]=\"type\"\r\n           [formControlName]=\"formControlName\"\r\n           [min]=\"min\"\r\n           [max]=\"max\"\r\n           [maxLength]=\"maxLength\"\r\n           [step]=\"step\"\r\n           [mask]=\"mask\"\r\n           [value]=\"value\">\r\n    <span *ngIf=\"suffix\">{{suffix}}</span>\r\n    <mat-hint *ngIf=\"hint\">{{hint}}</mat-hint>\r\n    <mat-hint *ngIf=\"showLength\">{{inputId.value.length}}/{{maxLength ?? 0}}</mat-hint>\r\n</mat-form-field>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i3$1.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3$1.MatLabel, selector: "mat-label" }, { kind: "directive", type: i3$1.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i6.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i6.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: i12.NgxMaskDirective, selector: "input[mask], textarea[mask]", inputs: ["mask", "specialCharacters", "patterns", "prefix", "suffix", "thousandSeparator", "decimalMarker", "dropSpecialCharacters", "hiddenInput", "showMaskTyped", "placeHolderCharacter", "shownMaskExpression", "showTemplate", "clearIfNotMatch", "validation", "separatorLimit", "allowNegativeNumbers", "leadZeroDateTime", "leadZero", "triggerOnMaskChange", "apm", "inputTransformFn", "outputTransformFn", "keepCharacterPositions"], outputs: ["maskFilled"], exportAs: ["mask", "ngxMask"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-input', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => InputComponent),
                            multi: true
                        }
                    ], template: "<mat-form-field [appearance]=\"appearance\" [formGroup]=\"formGroup\" style=\"width: 100%\">\r\n    <mat-label>{{label}}</mat-label>\r\n    <span *ngIf=\"prefix\">{{prefix}}</span>\r\n    <input matInput\r\n            #inputId\r\n           [placeholder]=\"placeholder\"\r\n           [required]=\"required\"\r\n           [readonly]=\"readonly\"\r\n           [disabled]=\"disabled\"\r\n           [type]=\"type\"\r\n           [formControlName]=\"formControlName\"\r\n           [min]=\"min\"\r\n           [max]=\"max\"\r\n           [maxLength]=\"maxLength\"\r\n           [step]=\"step\"\r\n           [mask]=\"mask\"\r\n           [value]=\"value\">\r\n    <span *ngIf=\"suffix\">{{suffix}}</span>\r\n    <mat-hint *ngIf=\"hint\">{{hint}}</mat-hint>\r\n    <mat-hint *ngIf=\"showLength\">{{inputId.value.length}}/{{maxLength ?? 0}}</mat-hint>\r\n</mat-form-field>\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { label: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], required: [{
                type: Input
            }], readonly: [{
                type: Input
            }], disabled: [{
                type: Input
            }], showLength: [{
                type: Input
            }], value: [{
                type: Input
            }], type: [{
                type: Input
            }], step: [{
                type: Input
            }], minLength: [{
                type: Input
            }], maxLength: [{
                type: Input
            }], length: [{
                type: Input
            }], hint: [{
                type: Input
            }], appearance: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], formGroup: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], matAutoComplete: [{
                type: Input
            }], mask: [{
                type: Input
            }], prefix: [{
                type: Input
            }], suffix: [{
                type: Input
            }], specialCharacters: [{
                type: Input
            }] } });

const maskConfig = {
    validation: false,
    allowNegativeNumbers: true,
    decimalMarker: ",",
    thousandSeparator: ".",
    clearIfNotMatch: false,
};
class InputModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: InputModule, declarations: [InputComponent], imports: [CommonModule,
            MatInputModule,
            MatAutocompleteModule,
            ReactiveFormsModule,
            NgxMaskDirective], exports: [InputComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InputModule, imports: [CommonModule,
            MatInputModule,
            MatAutocompleteModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        InputComponent,
                    ],
                    imports: [
                        CommonModule,
                        MatInputModule,
                        MatAutocompleteModule,
                        ReactiveFormsModule,
                        NgxMaskDirective,
                    ],
                    providers: [],
                    exports: [
                        InputComponent,
                    ]
                }]
        }] });

class BreadcumbModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BreadcumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: BreadcumbModule, declarations: [BreadcumbComponent], imports: [CommonModule,
            RouterLink], exports: [BreadcumbComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BreadcumbModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BreadcumbModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        BreadcumbComponent
                    ],
                    exports: [
                        BreadcumbComponent
                    ],
                    imports: [
                        CommonModule,
                        RouterLink
                    ]
                }]
        }] });

class SelectModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: SelectModule, declarations: [SelectComponent], imports: [CommonModule,
            MatSelectModule,
            ReactiveFormsModule], exports: [SelectComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SelectModule, imports: [CommonModule,
            MatSelectModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SelectModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SelectComponent,
                    ],
                    imports: [
                        CommonModule,
                        MatSelectModule,
                        ReactiveFormsModule,
                    ],
                    exports: [
                        SelectComponent,
                    ]
                }]
        }] });

class DatepickerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DatepickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DatepickerModule, declarations: [DatepickerComponent], imports: [CommonModule,
            MatInputModule,
            MatDatepickerModule,
            MatNativeDateModule,
            MatButtonModule,
            ReactiveFormsModule], exports: [DatepickerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DatepickerModule, imports: [CommonModule,
            MatInputModule,
            MatDatepickerModule,
            MatNativeDateModule,
            MatButtonModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DatepickerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DatepickerComponent,
                    ],
                    imports: [
                        CommonModule,
                        MatInputModule,
                        MatDatepickerModule,
                        MatNativeDateModule,
                        MatButtonModule,
                        ReactiveFormsModule,
                    ],
                    exports: [
                        DatepickerComponent,
                    ]
                }]
        }] });

class ListModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ListModule, declarations: [ListComponent,
            AdvancedFilterComponent], imports: [CommonModule,
            MatButtonModule,
            MatTableModule,
            MatInputModule,
            MatPaginatorModule,
            MatSortModule,
            InputModule,
            ButtonMenuModule,
            BreadcumbModule,
            MatDialogModule,
            ReactiveFormsModule,
            SelectModule,
            DatepickerModule,
            MatDatepickerModule,
            MatCheckboxModule,
            MatRadioModule,
            NgxMaskDirective,
            NgxCurrencyDirective,
            MatSliderModule], exports: [ListComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ListModule, imports: [CommonModule,
            MatButtonModule,
            MatTableModule,
            MatInputModule,
            MatPaginatorModule,
            MatSortModule,
            InputModule,
            ButtonMenuModule,
            BreadcumbModule,
            MatDialogModule,
            ReactiveFormsModule,
            SelectModule,
            DatepickerModule,
            MatDatepickerModule,
            MatCheckboxModule,
            MatRadioModule,
            MatSliderModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ListModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ListComponent,
                        AdvancedFilterComponent
                    ],
                    imports: [
                        CommonModule,
                        MatButtonModule,
                        MatTableModule,
                        MatInputModule,
                        MatPaginatorModule,
                        MatSortModule,
                        InputModule,
                        ButtonMenuModule,
                        BreadcumbModule,
                        MatDialogModule,
                        ReactiveFormsModule,
                        SelectModule,
                        DatepickerModule,
                        MatDatepickerModule,
                        MatCheckboxModule,
                        MatRadioModule,
                        NgxMaskDirective,
                        NgxCurrencyDirective,
                        MatSliderModule,
                    ],
                    exports: [
                        ListComponent
                    ]
                }]
        }] });

class FormComponent {
    constructor(router) {
        this.router = router;
        this.service = {};
        this.title = "";
        this.basicRoute = "";
        this.formGroup = new FormGroup({});
        this.primaryKey = '';
        this.backendRoute = "";
        this.actionButtons = [];
        this.showSaveButton = true;
        this.badgesStatus = [];
        this.breadcumbConfigs = [];
    }
    ngOnInit() {
        if (this.primaryKey?.trim() === '') {
            const msg = 'Configure o campo da chave primaria na propriedade "primaryKey"';
            if (this.service) {
                this.service?.toasterWarning(msg);
            }
            else {
                alert(msg);
            }
        }
    }
    async save() {
        try {
            if (this.primaryKey.trim() === '') {
                this.service.toasterWarning('Campo de chave primária não configurada. Impossível gravar');
                return;
            }
            const x = this.formGroup?.get(this.primaryKey)?.value;
            this.service.showSpinner();
            if (!x) {
                this.formGroup?.get(this.primaryKey)?.setValue(0);
                await this.service.post(this.backendRoute, this.formGroup.getRawValue()).toPromise();
            }
            else {
                await this.service.put(this.backendRoute + '/' + x, this.formGroup.getRawValue()).toPromise();
            }
            this.service.toasterSuccess('Salvo');
            await this.router.navigate([this.basicRoute]);
        }
        catch (e) {
            console.error(e);
            this.service.toasterDanger(e?.error);
        }
        finally {
            this.service.hideSpinner();
        }
    }
    cancel() {
        this.router.navigate([this.basicRoute]);
    }
    delete() {
        try {
            if (this.primaryKey.trim() === '') {
                this.service.toasterWarning('Campo de chave primária não configurada. Impossível gravar');
                return;
            }
            this.service.showSpinner();
        }
        catch (e) {
            console.error(e);
            this.service.toasterDanger('Erro ao excluir');
        }
        finally {
            this.service.hideSpinner();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormComponent, deps: [{ token: i1.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FormComponent, selector: "app-form", inputs: { service: "service", title: "title", basicRoute: "basicRoute", formGroup: "formGroup", primaryKey: "primaryKey", backendRoute: "backendRoute", actionButtons: "actionButtons", showSaveButton: "showSaveButton", badgesStatus: "badgesStatus", breadcumbConfigs: "breadcumbConfigs" }, ngImport: i0, template: "<div class=\"form\">\r\n  <div class=\"animated fade-in\">\r\n    <div class=\"row\">\r\n      <div class=\"col-12\">\r\n        <breadcumb [configs]=\"breadcumbConfigs\"></breadcumb>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\" id=\"mainForm\">\r\n      <div class=\"col-12\">\r\n        <div class=\"card\">\r\n          <div class=\"card-header\">\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-12 col-md-8\">\r\n                <h3 class=\"title\">{{title}} <app-badge-status *ngFor=\"let badge of badgesStatus\" [color]=\"badge.class\" [name]=\"badge.label\"></app-badge-status></h3>\r\n              </div>\r\n              <div class=\"col-xs-12 col-md-4\">\r\n                <div class=\"direita\">\r\n                  <app-button-menu *ngFor=\"let button of actionButtons\" [label]=\"button.label\" [color]=\"button.color\" [menus]=\"button.options\"></app-button-menu>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"card-body\">\r\n            <form>\r\n              <ng-content></ng-content>\r\n            </form>\r\n          </div>\r\n          <div class=\"card-footer\">\r\n            <div class=\"direita\">\r\n              <button mat-raised-button mat-button (click)=\"cancel()\">Cancelar</button>\r\n              <button *ngIf=\"showSaveButton\" mat-button mat-raised-button color=\"primary\" (click)=\"save()\" [disabled]=\"!formGroup.valid\">Gravar</button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".title{font-weight:700}.direita{text-align:right}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i4.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i6.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "component", type: ButtonMenuComponent, selector: "app-button-menu", inputs: ["label", "menus", "color", "yPosition", "xPosition"] }, { kind: "component", type: BadgeStatusComponent, selector: "app-badge-status", inputs: ["name", "color"] }, { kind: "component", type: BreadcumbComponent, selector: "breadcumb", inputs: ["configs"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-form', template: "<div class=\"form\">\r\n  <div class=\"animated fade-in\">\r\n    <div class=\"row\">\r\n      <div class=\"col-12\">\r\n        <breadcumb [configs]=\"breadcumbConfigs\"></breadcumb>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\" id=\"mainForm\">\r\n      <div class=\"col-12\">\r\n        <div class=\"card\">\r\n          <div class=\"card-header\">\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-12 col-md-8\">\r\n                <h3 class=\"title\">{{title}} <app-badge-status *ngFor=\"let badge of badgesStatus\" [color]=\"badge.class\" [name]=\"badge.label\"></app-badge-status></h3>\r\n              </div>\r\n              <div class=\"col-xs-12 col-md-4\">\r\n                <div class=\"direita\">\r\n                  <app-button-menu *ngFor=\"let button of actionButtons\" [label]=\"button.label\" [color]=\"button.color\" [menus]=\"button.options\"></app-button-menu>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"card-body\">\r\n            <form>\r\n              <ng-content></ng-content>\r\n            </form>\r\n          </div>\r\n          <div class=\"card-footer\">\r\n            <div class=\"direita\">\r\n              <button mat-raised-button mat-button (click)=\"cancel()\">Cancelar</button>\r\n              <button *ngIf=\"showSaveButton\" mat-button mat-raised-button color=\"primary\" (click)=\"save()\" [disabled]=\"!formGroup.valid\">Gravar</button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n", styles: [".title{font-weight:700}.direita{text-align:right}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.Router }]; }, propDecorators: { service: [{
                type: Input
            }], title: [{
                type: Input
            }], basicRoute: [{
                type: Input
            }], formGroup: [{
                type: Input
            }], primaryKey: [{
                type: Input
            }], backendRoute: [{
                type: Input
            }], actionButtons: [{
                type: Input
            }], showSaveButton: [{
                type: Input
            }], badgesStatus: [{
                type: Input
            }], breadcumbConfigs: [{
                type: Input
            }] } });

class FileUploadComponent {
    constructor() { }
    ngOnInit() {
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileUploadComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: FileUploadComponent, selector: "app-file-upload", ngImport: i0, template: "<p>file-upload works!</p>\r\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-file-upload', template: "<p>file-upload works!</p>\r\n" }]
        }], ctorParameters: function () { return []; } });

class FileUploadModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FileUploadModule, declarations: [FileUploadComponent], imports: [CommonModule], exports: [FileUploadComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileUploadModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FileUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FileUploadComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        FileUploadComponent,
                    ]
                }]
        }] });

class FormModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FormModule, declarations: [FormComponent], imports: [CommonModule,
            MatButtonModule,
            MatInputModule,
            MatFormFieldModule,
            ReactiveFormsModule,
            FileUploadModule,
            RouterModule,
            ButtonMenuModule,
            BadgeStatusModule,
            BreadcumbModule], exports: [FormComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormModule, imports: [CommonModule,
            MatButtonModule,
            MatInputModule,
            MatFormFieldModule,
            ReactiveFormsModule,
            FileUploadModule,
            RouterModule,
            ButtonMenuModule,
            BadgeStatusModule,
            BreadcumbModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FormComponent,
                    ],
                    imports: [
                        CommonModule,
                        MatButtonModule,
                        MatInputModule,
                        MatFormFieldModule,
                        ReactiveFormsModule,
                        FileUploadModule,
                        RouterModule,
                        ButtonMenuModule,
                        BadgeStatusModule,
                        BreadcumbModule,
                    ],
                    exports: [
                        FormComponent,
                    ]
                }]
        }] });

class TableComponent {
    constructor(router) {
        this.router = router;
        this.displayedColumns = [];
        this.dataSource = {};
        this.defaultRoute = '';
        this.defaultEmptyResultMessage = 'Nenhum registro encontrado.';
        this.fieldsFormatted = [];
        this.primaryKey = '';
        this.displayedColumnsFiltered = [];
    }
    ngOnInit() {
        for (const x of this.displayedColumns) {
            if (x.visible) {
                this.fieldsFormatted.push(x.fieldName);
            }
            if (x.primaryKey) {
                this.primaryKey = x.fieldName;
            }
        }
    }
    formatMatHeaderRowDef(arr) {
        const y = new Array();
        for (const x of arr) {
            y.push(x.fieldName);
        }
        return y;
    }
    async open(id) {
        await this.router.navigate([this.defaultRoute + id]);
    }
    filterHiddenColumns() {
        this.displayedColumns.forEach(y => {
            if (y.visible) {
                this.displayedColumnsFiltered.push(y);
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TableComponent, deps: [{ token: i1.Router }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: TableComponent, selector: "app-table", inputs: { displayedColumns: "displayedColumns", dataSource: "dataSource", defaultRoute: "defaultRoute", defaultEmptyResultMessage: "defaultEmptyResultMessage" }, ngImport: i0, template: "<div *ngIf=\"dataSource?.data?.length ?? 0 > 0; else semResultado\">\r\n  <table class=\"table-hover\" mat-table [dataSource]=\"dataSource\" class=\"mat-elevation-z8\" width=\"100%\">\r\n    <ng-container *ngFor=\"let field of displayedColumns\" [matColumnDef]=\"field.fieldName\">\r\n      <th class=\"text-center\" mat-header-cell mat-sort-header *matHeaderCellDef=\"field.visible \"> {{field.canonicalName}} </th>\r\n      <td class=\"clickable\" [innerHTML]=\"field.pipe(element[field.fieldName])\" [ngClass]=\"!field.visible ? 'hidden' : field.columnClasses\" mat-cell *matCellDef=\"let element\"></td>\r\n    </ng-container>\r\n    <tr mat-header-row *matHeaderRowDef=\"formatMatHeaderRowDef(displayedColumns)\"></tr>\r\n    <tr class=\"small\" mat-row *matRowDef=\"let row; columns: fieldsFormatted;\" style=\"cursor:pointer;\" (click)=\"open(row[primaryKey])\">{{row | json}}</tr>\r\n  </table>\r\n</div>\r\n<ng-template #semResultado>\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <div class=\"alert alert-info text-center\">\r\n        <strong>{{defaultEmptyResultMessage}}</strong>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i5.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i5.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i5.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i5.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i5.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i5.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i5.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i5.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i5.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i5.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "pipe", type: i1$1.JsonPipe, name: "json" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-table', template: "<div *ngIf=\"dataSource?.data?.length ?? 0 > 0; else semResultado\">\r\n  <table class=\"table-hover\" mat-table [dataSource]=\"dataSource\" class=\"mat-elevation-z8\" width=\"100%\">\r\n    <ng-container *ngFor=\"let field of displayedColumns\" [matColumnDef]=\"field.fieldName\">\r\n      <th class=\"text-center\" mat-header-cell mat-sort-header *matHeaderCellDef=\"field.visible \"> {{field.canonicalName}} </th>\r\n      <td class=\"clickable\" [innerHTML]=\"field.pipe(element[field.fieldName])\" [ngClass]=\"!field.visible ? 'hidden' : field.columnClasses\" mat-cell *matCellDef=\"let element\"></td>\r\n    </ng-container>\r\n    <tr mat-header-row *matHeaderRowDef=\"formatMatHeaderRowDef(displayedColumns)\"></tr>\r\n    <tr class=\"small\" mat-row *matRowDef=\"let row; columns: fieldsFormatted;\" style=\"cursor:pointer;\" (click)=\"open(row[primaryKey])\">{{row | json}}</tr>\r\n  </table>\r\n</div>\r\n<ng-template #semResultado>\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <div class=\"alert alert-info text-center\">\r\n        <strong>{{defaultEmptyResultMessage}}</strong>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.Router }]; }, propDecorators: { displayedColumns: [{
                type: Input
            }], dataSource: [{
                type: Input
            }], defaultRoute: [{
                type: Input
            }], defaultEmptyResultMessage: [{
                type: Input
            }] } });

class TableModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: TableModule, declarations: [TableComponent], imports: [CommonModule,
            MatTableModule], exports: [TableComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TableModule, imports: [CommonModule,
            MatTableModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        TableComponent
                    ],
                    imports: [
                        CommonModule,
                        MatTableModule,
                    ],
                    exports: [
                        TableComponent,
                    ]
                }]
        }] });

class SelectAutoCompleteComponent {
    constructor() {
        this.label = '';
        this.placeholder = '';
        this.required = false;
        this.readonly = false;
        this.disabled = false;
        this.value = '';
        this.type = 'text';
        this.minLength = 255;
        this.maxLength = 255;
        this.length = 255;
        this.hint = '';
        this.appearance = 'fill';
        this.formControlName = '';
        this.formGroup = new FormGroup({});
        this.min = 0;
        this.max = 0;
        this.service = {};
        this.backendRoute = "";
        this.displayFn = (value) => value;
        this.options = [];
    }
    async ngOnInit() {
    }
    async search(query) {
        let data = [];
        if (!query) {
            return data;
        }
        try {
            this.service.showSpinner();
            data = await lastValueFrom(this.service.get(this.backendRoute + "?query=" + query));
            if (data.length == 0) {
                this.service.toasterInfo("Nenhum registro encontrado para este filtro");
            }
            this.options = data;
        }
        catch (e) {
            console.error(e);
            this.service.toasterDanger(e.error ?? "Houve um erro ao realizar esta busca");
        }
        finally {
            this.service.hideSpinner();
        }
        return data;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SelectAutoCompleteComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: SelectAutoCompleteComponent, selector: "app-select-auto-complete", inputs: { label: "label", placeholder: "placeholder", required: "required", readonly: "readonly", disabled: "disabled", value: "value", type: "type", minLength: "minLength", maxLength: "maxLength", length: "length", hint: "hint", appearance: "appearance", formControlName: "formControlName", formGroup: "formGroup", min: "min", max: "max", service: "service", backendRoute: "backendRoute", displayFn: "displayFn" }, ngImport: i0, template: "<mat-form-field style=\"width: 100%\" [formGroup]=\"formGroup\">\r\n    <mat-label *ngIf=\"label\">{{label}}</mat-label>\r\n    <input type=\"hidden\"\r\n           [formGroup]=\"formGroup\"\r\n           [formControlName]=\"formControlName\"\r\n           [value]=\"value\"\r\n    >\r\n    <input #searchInput\r\n           matInput\r\n           [type]=\"type\"\r\n           [required]=\"required\"\r\n           [placeholder]=\"placeholder\"\r\n           [readonly]=\"readonly\"\r\n           [disabled]=\"disabled\"\r\n           [minLength]=\"minLength\"\r\n           [maxLength]=\"maxLength\"\r\n           [min]=\"min\"\r\n           [max]=\"max\"\r\n           (keydown.enter)=\"search(searchInput.value)\"\r\n           (blur)=\"search(searchInput.value)\"\r\n           [matAutocomplete]=\"auto\"\r\n    >\r\n    <mat-hint *ngIf=\"hint\">{{hint}}</mat-hint>\r\n    <mat-autocomplete #auto=\"matAutocomplete\" [displayWith]=\"displayFn\">\r\n        <mat-option *ngFor=\"let option of options\" [value]=\"option\">\r\n            {{option.option}}\r\n        </mat-option>\r\n    </mat-autocomplete>\r\n</mat-form-field>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i3$1.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3$1.MatLabel, selector: "mat-label" }, { kind: "directive", type: i3$1.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "component", type: i4$3.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple", "hideSingleSelectionIndicator"], exportAs: ["matAutocomplete"] }, { kind: "component", type: i4$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "directive", type: i4$3.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }, { kind: "directive", type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i6.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i6.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SelectAutoCompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-select-auto-complete', template: "<mat-form-field style=\"width: 100%\" [formGroup]=\"formGroup\">\r\n    <mat-label *ngIf=\"label\">{{label}}</mat-label>\r\n    <input type=\"hidden\"\r\n           [formGroup]=\"formGroup\"\r\n           [formControlName]=\"formControlName\"\r\n           [value]=\"value\"\r\n    >\r\n    <input #searchInput\r\n           matInput\r\n           [type]=\"type\"\r\n           [required]=\"required\"\r\n           [placeholder]=\"placeholder\"\r\n           [readonly]=\"readonly\"\r\n           [disabled]=\"disabled\"\r\n           [minLength]=\"minLength\"\r\n           [maxLength]=\"maxLength\"\r\n           [min]=\"min\"\r\n           [max]=\"max\"\r\n           (keydown.enter)=\"search(searchInput.value)\"\r\n           (blur)=\"search(searchInput.value)\"\r\n           [matAutocomplete]=\"auto\"\r\n    >\r\n    <mat-hint *ngIf=\"hint\">{{hint}}</mat-hint>\r\n    <mat-autocomplete #auto=\"matAutocomplete\" [displayWith]=\"displayFn\">\r\n        <mat-option *ngFor=\"let option of options\" [value]=\"option\">\r\n            {{option.option}}\r\n        </mat-option>\r\n    </mat-autocomplete>\r\n</mat-form-field>\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { label: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], required: [{
                type: Input
            }], readonly: [{
                type: Input
            }], disabled: [{
                type: Input
            }], value: [{
                type: Input
            }], type: [{
                type: Input
            }], minLength: [{
                type: Input
            }], maxLength: [{
                type: Input
            }], length: [{
                type: Input
            }], hint: [{
                type: Input
            }], appearance: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], formGroup: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], service: [{
                type: Input
            }], backendRoute: [{
                type: Input
            }], displayFn: [{
                type: Input
            }] } });

class SelectAutoCompleteModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SelectAutoCompleteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: SelectAutoCompleteModule, declarations: [SelectAutoCompleteComponent], imports: [CommonModule,
            InputModule,
            MatInputModule,
            MatAutocompleteModule,
            MatFormFieldModule,
            ReactiveFormsModule], exports: [SelectAutoCompleteComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SelectAutoCompleteModule, imports: [CommonModule,
            InputModule,
            MatInputModule,
            MatAutocompleteModule,
            MatFormFieldModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SelectAutoCompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SelectAutoCompleteComponent
                    ],
                    imports: [
                        CommonModule,
                        InputModule,
                        MatInputModule,
                        MatAutocompleteModule,
                        MatFormFieldModule,
                        ReactiveFormsModule,
                    ],
                    exports: [
                        SelectAutoCompleteComponent,
                    ]
                }]
        }] });

const getBaseUrl = () => {
    const actualUrl = window.location.origin ?? "";
    const maps = {
        //      "http://localhost:5000" : "http://localhost:5146/",
        //      "http://localhost:5001" : "http://localhost:5146/",
        //       "http://localhost:5147" : "http://localhost:5146/",
        "http://localhost:4200": "https://localhost:7146/",
    };
    let ret = '';
    if (maps.hasOwnProperty(actualUrl)) {
        ret = maps[actualUrl];
    }
    else {
        ret = actualUrl + '/';
    }
    return ret;
};

const environment$1 = {
    production: true,
    baseUrl: getBaseUrl(),
};

/**
 * @class BaseService
 * @author Victor Vilella
 * @summary Classe que será responsável por ser mãe de todas as classes de serviço do sistema
 */
class BaseService {
    constructor(httpClient, toaster, spinner, router, activatedRoute, datePipe, currencyPipe) {
        this.httpClient = httpClient;
        this.toaster = toaster;
        this.spinner = spinner;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.datePipe = datePipe;
        this.currencyPipe = currencyPipe;
        this.options = {
            headers: {
                'content-type': 'application/json',
                'Authorization': localStorage.getItem('x-session-token'),
                'x-database-group': localStorage.getItem('x-database-group'),
                'x-session-token': localStorage.getItem('x-session-token'),
            }
        };
    }
    /**
     * Constroi da Base Url do backend
     * @param url
     * @return string
     */
    static buildUrl(url) {
        return environment$1.baseUrl + url;
    }
    showErrorMessage(e) {
        console.error(e);
        this.toasterDanger('', 'Erro');
    }
    /**
     * Mostra o Spinner
     */
    showSpinner() {
        this.spinner.show();
    }
    /**
     * Esconde o Spinner
     */
    hideSpinner() {
        this.spinner.hide();
    }
    /**
     * Exibe um toaster de informaçāo (na cor azul)
     * @param msg
     * @param title
     */
    toasterInfo(msg, title = '') {
        this.toaster.info(msg, title);
    }
    /**
     * Exibe um toaster de sucesso (na cor verde)
     * @param msg
     * @param title
     */
    toasterSuccess(msg, title = '') {
        this.toaster.success(msg, title);
    }
    /**
     * Exibe um toaster de aviso (Cor laranja)
     * @param msg
     * @param title
     */
    toasterWarning(msg, title = '') {
        this.toaster.warning(msg, title);
    }
    /**
     * Exibe um toaster de erro (Cor Vermelha)
     * @param msg
     * @param title
     */
    toasterDanger(msg, title = '') {
        this.toaster.error(msg, title);
    }
    /**
     *
     */
    clearToasters() {
        this.toaster.clear();
    }
    /**
     * Faz uma requisiçāo de GET ao backend
     * @param url
     * @return Observable
     */
    get(url) {
        return this.httpClient.get(BaseService.buildUrl(url), this.options);
    }
    /**
     * Faz uma requisiçāo de POST ao backend
     * @param url
     * @param data
     * @return Observable
     */
    post(url, data) {
        return this.httpClient.post(BaseService.buildUrl(url), data, this.options);
    }
    /**
     * Faz uma requisiçāo de PUT ao backend
     * @param url
     * @param data
     * @return Observable
     */
    put(url, data) {
        return this.httpClient.put(BaseService.buildUrl(url), data, this.options);
    }
    /**
     * Faz uma requisiçāo de DELETE ao backend
     * @param url
     * @return Observable
     */
    delete(url) {
        return this.httpClient.delete(url, this.options);
    }
    /**
     * Faz um patch no servidor
     * @param url
     * @param data
     */
    patch(url, data) {
        return this.httpClient.patch(BaseService.buildUrl(url), data, this.options);
    }
    /**
     * Faz uma requisiçāo de listagem de objetos ao backend
     * @param url
     * @param query
     * @param advancedQuery
     * @param first
     * @param skip
     * @param order
     * @param direction
     * @param page
     * @return Observable
     */
    index(url, query = '', advancedQuery = {}, first = 20, skip = 0, order = '', direction = 'asc', page = 1) {
        return this.httpClient.get(BaseService.buildUrl(url) + '?first=' + first + '&skip=' + skip + '&query=' + query + '&page=' + page + "&query_advanced=" + JSON.stringify(advancedQuery), this.options);
    }
    /***
     * Faz uma requisicao ao backend da quantidade de objetos disponiveis
     * @param url
     * @param query
     * @param advancedQuery
     */
    count(url, query = '', advancedQuery = {}) {
        return this.httpClient.get(BaseService.buildUrl(url + '?query=' + query + "&query_advanced=" + JSON.stringify(advancedQuery)), this.options);
    }
    /**
     * Formata a data
     * @param date
     */
    formatAsDate(date) {
        return this.datePipe.transform(date, 'dd/MM/yyyy');
    }
    /**
     * Formata em timestamp
     * @param date
     */
    formatAsTimestamp(date) {
        return this.datePipe.transform(date, 'dd/MM/yyyy HH:ii:ss');
    }
    /**
     * Formata dinheiro
     * @param money
     */
    formatAsCurrency(money) {
        return this.currencyPipe.transform(money);
    }
    /**
     * @return string
     */
    getId() {
        return this.activatedRoute?.snapshot?.params["id"];
    }
    formatSimNao() {
        return [
            {
                option: "Sim",
                value: "S",
            },
            {
                option: "Não",
                value: "N",
            },
        ];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseService, deps: [{ token: i1$3.HttpClient }, { token: i2$1.ToastrService }, { token: i3$3.NgxSpinnerService }, { token: i1.Router }, { token: i1.ActivatedRoute }, { token: i1$1.DatePipe }, { token: i1$1.CurrencyPipe }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BaseService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$3.HttpClient }, { type: i2$1.ToastrService }, { type: i3$3.NgxSpinnerService }, { type: i1.Router }, { type: i1.ActivatedRoute }, { type: i1$1.DatePipe }, { type: i1$1.CurrencyPipe }]; } });

class CepServiceService {
    constructor(http) {
        this.http = http;
    }
    consultaCep(cep) {
        return this.http.get('https://viacep.com.br/ws/' + cep + '/json');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CepServiceService, deps: [{ token: i1$3.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CepServiceService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CepServiceService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$3.HttpClient }]; } });

class StateService extends BaseService {
    states() {
        return this.get('state');
    }
    cep(cep) {
        return this.get('cep/' + cep);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateService, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: StateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
const environment = {
    production: false,
    baseUrl: getBaseUrl(),
};

class TextareaComponent {
    constructor() {
        this.appearance = "fill";
        this.label = "";
        this.placeholder = "";
        this.formControlName = "";
        this.formGroup = new FormGroup({});
        this.maxLength = 1000;
        this.color = 'primary';
        this.required = false;
        this.readonly = false;
        this.disabled = false;
        this.showLength = false;
        this.hint = "";
    }
    ngOnInit() {
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TextareaComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: TextareaComponent, selector: "app-textarea", inputs: { appearance: "appearance", label: "label", placeholder: "placeholder", formControlName: "formControlName", formGroup: "formGroup", maxLength: "maxLength", color: "color", required: "required", readonly: "readonly", disabled: "disabled", showLength: "showLength", hint: "hint" }, ngImport: i0, template: "<mat-form-field [appearance]=\"appearance\"\r\n                [formGroup]=\"formGroup\"\r\n                [color]=\"color\"\r\n>\r\n    <mat-label>{{label}}</mat-label>\r\n    <textarea matInput #textAreaId\r\n              [placeholder]=\"placeholder\"\r\n              [maxLength]=\"maxLength\"\r\n              [required]=\"required\"\r\n              [formControlName]=\"formControlName\"\r\n              [readonly]=\"readonly\"\r\n              [disabled]=\"disabled\"\r\n    ></textarea>\r\n    <mat-hint *ngIf=\"hint\">{{hint}}</mat-hint>\r\n    <mat-hint *ngIf=\"showLength\">{{textAreaId.value.length}}/{{maxLength}}</mat-hint>\r\n</mat-form-field>\r\n", styles: ["mat-form-field{width:100%}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3$1.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3$1.MatLabel, selector: "mat-label" }, { kind: "directive", type: i3$1.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i2.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i6.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i6.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i6.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i6.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i6.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i6.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TextareaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'app-textarea', template: "<mat-form-field [appearance]=\"appearance\"\r\n                [formGroup]=\"formGroup\"\r\n                [color]=\"color\"\r\n>\r\n    <mat-label>{{label}}</mat-label>\r\n    <textarea matInput #textAreaId\r\n              [placeholder]=\"placeholder\"\r\n              [maxLength]=\"maxLength\"\r\n              [required]=\"required\"\r\n              [formControlName]=\"formControlName\"\r\n              [readonly]=\"readonly\"\r\n              [disabled]=\"disabled\"\r\n    ></textarea>\r\n    <mat-hint *ngIf=\"hint\">{{hint}}</mat-hint>\r\n    <mat-hint *ngIf=\"showLength\">{{textAreaId.value.length}}/{{maxLength}}</mat-hint>\r\n</mat-form-field>\r\n", styles: ["mat-form-field{width:100%}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { appearance: [{
                type: Input
            }], label: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], formControlName: [{
                type: Input
            }], formGroup: [{
                type: Input
            }], maxLength: [{
                type: Input
            }], color: [{
                type: Input
            }], required: [{
                type: Input
            }], readonly: [{
                type: Input
            }], disabled: [{
                type: Input
            }], showLength: [{
                type: Input
            }], hint: [{
                type: Input
            }] } });

class TextareaModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TextareaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: TextareaModule, declarations: [TextareaComponent], imports: [CommonModule,
            MatFormFieldModule,
            MatInputModule,
            ReactiveFormsModule], exports: [TextareaComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TextareaModule, imports: [CommonModule,
            MatFormFieldModule,
            MatInputModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TextareaModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        TextareaComponent
                    ],
                    imports: [
                        CommonModule,
                        MatFormFieldModule,
                        MatInputModule,
                        ReactiveFormsModule,
                    ],
                    exports: [
                        TextareaComponent,
                    ]
                }]
        }] });

/*
 * Public API Surface of ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BadgeStatusComponent, BadgeStatusModule, BaseService, BreadcumbComponent, BreadcumbModule, ButtonMenuComponent, ButtonMenuModule, CepServiceService, ComponentesPadraoComponent, ComponentesPadraoModule, ComponentesPadraoService, Constants, DatepickerComponent, DatepickerModule, FilterType, FormComponent, FormModule, InputComponent, InputModule, ListComponent, ListModule, ModalDialogComponent, ModalDialogModule, ModalDialogService, SelectAutoCompleteComponent, SelectAutoCompleteModule, SelectComponent, SelectModule, StateService, TableComponent, TableModule, TextareaComponent, TextareaModule, UiComponent, UiModule, UiService, defaultNgxCurrency, environment, getBaseUrl, ngxMaskConfig };
